export default {
  wallet: {
    main: "اصلی",
    spot: "اسپات",
    portfolio: "پورتفولیو (به زودی)"
  },
  operations: {
    deposit: "واریز",
    withdrawal: "برداشت",
    exchange: "تبدیل",
    transfer: "انتقال"
  },
  history: {
    openOrders: "سفارشات (اسپات)",
    profitLossLimit: "حد سود و ضرر (اسپات)",
    transactions: "تراکنش‌ها (اسپات)",
    otc: "تبدیل سریع و سفارش گذاری"
  }
};
